import {StandingsWidgetStore} from "./standings-widget.store";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {StandingsWidgetConfig} from "./standings-widget.config";
import {StandingsDomainService} from "../../domain/standings/services/standings.domain-service";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {StandingsWidgetHandlers} from "./handlers/standings-widget.handlers";

export class StandingsWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, StandingsWidgetConfig, StandingsWidgetStore, StandingsWidgetHandlers, StandingsDomainService];
}

